var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topicThree"},[_c('canvas',{ref:"qtchess",staticStyle:{"width":"100%"},attrs:{"width":"500","height":"500"}}),_c('div',{staticClass:"button",on:{"click":_vm.confirmAns}},[_vm._v("确定")])])}
var staticRenderFns = []

export { render, staticRenderFns }